module.exports = __webpack_public_path__ + "e097b71641f2524e09820d9122b7e910.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Ubuntu_Mono/UbuntuMono-Regular.ttf
// module id = 372
// module chunks = 0